export const photoArticleAllowedWidgets = ['photos', 'text', 'dummy']
